export interface TileSource {
  url: string;
  /** 지도에 반드시 노출해야 하는 출처 표기. */
  attribution: string;
  attributionUrl?: string;
  maxZoom: number;
  maxNativeZoom?: number;
  /** 위성/항공 영상 여부 — 라벨 오버레이를 얹을지 판단에 쓴다. */
  imagery: boolean;
}

export const ESRI_IMAGERY: TileSource = {
  url: "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}",
  attribution: "Esri, Vantor, Earthstar Geographics, and the GIS User Community",
  maxZoom: 19,
  imagery: true,
};

const VWORLD_KEY = (import.meta.env.VITE_VWORLD_KEY ?? "").trim();

export const VWORLD_SATELLITE: TileSource = {
  url: `https://api.vworld.kr/req/wmts/1.0.0/${VWORLD_KEY}/Satellite/{z}/{y}/{x}.jpeg`,
  attribution: "국토지리정보원 VWorld",
  maxZoom: 19,
  imagery: true,
};

export function imagerySource(): TileSource {
  return VWORLD_KEY ? VWORLD_SATELLITE : ESRI_IMAGERY;
}

export const VWORLD_BASE: TileSource = {
  url: `https://api.vworld.kr/req/wmts/1.0.0/${VWORLD_KEY}/Base/{z}/{y}/{x}.png`,
  attribution: "국토지리정보원 VWorld",
  maxZoom: 19,
  imagery: false,
};

export const OSM_STANDARD: TileSource = {
  url: "https://tile.openstreetmap.org/{z}/{x}/{y}.png",
  attribution: "© OpenStreetMap contributors",
  attributionUrl: "https://www.openstreetmap.org/copyright",
  maxZoom: 19,
  imagery: false,
};

export function basemapSource(): TileSource {
  return VWORLD_KEY ? VWORLD_BASE : OSM_STANDARD;
}
